import { lazy } from 'react';
import Loadable from '../../components/Loadable';
import { BannersProvider } from "../../contexts/banners/BannerContext";

const BannerFragment = Loadable(lazy(() => import('./view/BannerFragment')));

const bannerRoutes = [
    { path: '/banners', element: <BannersProvider><BannerFragment /></BannersProvider> },
];

export default bannerRoutes;
